/**
 * RemoveFromPipelineDialog — public entry point for the SE-5500 removal
 * confirmation. The Container owns the submit guard and the failure path and
 * renders the shared ConfirmDialog molecule, so there is no
 * feature-local View.
 * @module features/player-kanban/components/molecules/RemoveFromPipelineDialog
 */

export { default } from "./RemoveFromPipelineDialogContainer";
export type { RemoveFromPipelineDialogProps } from "./RemoveFromPipelineDialogContainer";
